import Storage from "./Storage";
import { getCookie, setCookie } from "./helpers";

class TokenKeeper {
    token = null;
    cookieName = 'auth_token';

    constructor() {
        this.token = getCookie(this.cookieName);

        if (!this.token) {
            const localToken = Storage.getItem('token');

            if (localToken) {
                this.setToken(localToken);
            }
        }
    }

    getToken() {
        return this.token;
    }

    setToken(token) {
        setCookie(this.cookieName, token, 365);

        this.token = token;
    }

    removeToken() {
        setCookie(this.cookieName, "", -1);
        Storage.removeItem('token');

        this.token = null;
    }
}

export default new TokenKeeper();